import React, { useEffect, useRef, useState } from 'react';
import { isVideoUrl } from '@/utils/mediaUtils';
import styles from './InfluencerReelCard.module.css';
import type { InfluencerReelCardProps } from './InfluencerReelCard.types';

export const InfluencerReelCard: React.FC<InfluencerReelCardProps> = ({
  video,
  onClick,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const isVideo = isVideoUrl(video.videoUrl);

  useEffect(() => {
    if (!isVideo) return;
    const videoNode = videoRef.current;
    if (videoNode) {
      videoNode.play().catch((err) => {
        console.warn('Autoplay preview video failed to play:', err);
      });
    }
  }, [isVideo]);

  const handleLoadedData = (): void => {
    setIsLoaded(true);
  };

  return (
    <div className={styles.card} onClick={onClick}>
      {isVideo ? (
        <video
          autoPlay
          loop
          muted
          playsInline
          className={`${styles.video} ${isLoaded ? styles.loaded : ''}`}
          ref={videoRef}
          src={video.videoUrl}
          onLoadedData={handleLoadedData}
        />
      ) : (
        <img
          className={`${styles.video} ${isLoaded ? styles.loaded : ''}`}
          src={video.videoUrl}
          alt={video.title || 'Influencer pick'}
          onLoad={handleLoadedData}
        />
      )}

      {!isLoaded && <div className={styles.shimmer} />}

      {isVideo && video.thumbnailUrl && !isLoaded && (
        <img
          src={video.thumbnailUrl}
          alt={video.title || 'Influencer pick preview'}
          className={styles.thumbnail}
        />
      )}
    </div>
  );
};

export default InfluencerReelCard;
